module.exports = __webpack_public_path__ + "img/logo-icon-white.4b38e654.png";